import { useState } from "react";

function useDragAndDrop(onFilesDrop) {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragging(true); // 顯示拖拉狀態
  };

  const handleDragLeave = () => {
    setIsDragging(false); // 移除拖拉狀態
  };


  const handleDrop = async (event) => {
    event.preventDefault();
    setIsDragging(false);
    const items = event.dataTransfer.items;
    const allFiles = [];

    const traverseFileTree = async (item, path = "") => {
      return new Promise((resolve) => {
        if (item.isFile) {
          item.file((file) => {
            file.relativePath = path + file.name; // 保留相對路徑資訊
            allFiles.push(file);
            resolve();
          });
        } else if (item.isDirectory) {
          const dirReader = item.createReader();
          dirReader.readEntries(async (entries) => {
            for (const entry of entries) {
              await traverseFileTree(entry, path + item.name + "/");
            }
            resolve();
          });
        }
      });
    };

    const entries = [];
    for (let i = 0; i < items.length; i++) {
      const item = items[i].webkitGetAsEntry?.();
      if (item) entries.push(item);
    }

    for (const entry of entries) {
      await traverseFileTree(entry);
    }

    console.log("✅ 全部取得的檔案列表：", allFiles);
    onFilesDrop(allFiles); // 丟給你原本的上傳邏輯
  };



  // const handleDrop = async (event) => {
  //     // event.preventDefault();
  //     // setIsDragging(false);

  //     // // 提取拖入的文件
  //     // const files = Array.from(event.dataTransfer.files);
  //     // if (files.length > 0) {
  //     //   onFilesDrop(files); // 回調處理文件
  //     // }

  // };

  return {
    isDragging,
    handleDragOver,
    handleDragLeave,
    handleDrop,
  };
}

export default useDragAndDrop;
